import { getEaster } from './getEaster';

export const isNextWorkingDay = (date: string, holidaysList: string[]): boolean => {
  const parsedDate = new Date(date.replace(/-/g, '/'));
  const today = new Date();

  if (today >= parsedDate) return false;

  const dayOfWeek = parsedDate.getDay();
  const dayWithoutYear = parsedDate.getMonth() + 1 + '-' + parsedDate.getDate();
  const easter = getEaster(parsedDate.getFullYear());
  const easterDate = new Date(parsedDate.getFullYear() + '-' + easter);
  const easterMonday = new Date(easterDate.setDate(easterDate.getDate() + 1));
  const holidaysListWithEaster = [...holidaysList, easter, easterMonday.getMonth() + 1 + '-' + easterMonday.getDate()];

  return !(dayOfWeek === 6 || dayOfWeek === 0 || holidaysListWithEaster.includes(dayWithoutYear));
};
